import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'list': [],
  'listByDealersAndModels': [],
  'saving': false,
};


export const saleForecast = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_SALE_FORECAST_BY_DEALERS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_SALE_FORECAST_BY_DEALERS]: (state, action) => ({
      ...state,
      'loading': false,
      'listByDealersAndModels': action.response.data,
    }),
    [ActionTypes.FETCHED_SALE_FORECAST_BY_DEALERS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'listByDealersAndModels': [],
    }),
    [ActionTypes.FETCHING_SALE_FORECAST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_SALE_FORECAST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_SALE_FORECAST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.SAVING_SALE_FORECAST_DATA]: (state, action) => ({
      ...state,
      'saving': true,
    }),
    [ActionTypes.SAVED_SALE_FORECAST_DATA]: (state, action) => ({
      ...state,
      'saving': false,
    }),
    [ActionTypes.SAVED_SALE_FORECAST_DATA_FAILED]: (state, action) => ({
      ...state,
      'saving': false,
    }),
    [ActionTypes.CLEAR_SALE_FORECAST_LIST]: (state, action) => ({
      ...state,
      'list': [],
      'loading': false,
    }),
  })(state, action);
};
  
  
const INITIAL_STATE_MAINTAIN = {
  'loading': false,
  'list': [],
};

export const agenciesComplete = (state, action) => {
  return createReducer(INITIAL_STATE_MAINTAIN, {
    [ActionTypes.FETCHING_MAINTAIN_SALE_FORECAST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_MAINTAIN_SALE_FORECAST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_MAINTAIN_SALE_FORECAST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.CLEAR_MAINTAIN_FORECAST_AGENCIES_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
  })(state, action);
};
